import { createSlice } from '@reduxjs/toolkit'



// const payload = {
//   requestOrderType: 2,
//   callType: 3,
//   user: {
//     type: 2,
//     name: '김영현',
//     phoneNo: '01077318996',
//     branchCode: '',
//     checkType: 2,
//   },
//   refTransNo: 'TRC000-2022-05-00001',
//   transNo: 'TRC000-2022-05-00001-P',
//   productType: 2,
//   productServiceType: 1,
//   routes: [
//     {
//       locationName: '김출발',
//       phoneNo: '01077318996',
//       addr: '서울시 강남구 역삼동 123',
//       addrDetail: '타임코빌딩 주차장',
//       locationType: '001',
//       car: {
//           brand: '현대',
//           vehicleModel: 'test',
//           carNo: '1231',
//       },
//     },
//     {
//         locationName: '김출발',
//         phoneNo: '01077318996',
//         addr: '서울시 강남구 역삼동 123',
//         addrDetail: '타임코빌딩 주차장',
//         locationType: '009',
//         car: {},
//     }
//   ], //  필요 값: locationName (이름), phoneNo (연락처), addr (출발지주소), addrDetail(주소상세), locationType (001:출발지 , 009:도착지)
//   reservationDate: '2023-03-16 16:00:00', // 예약 일자
//   assignType: 1, // 배차유형
//   assignDetail: '', // 배차유형 상세 (P: 픽업, D: 딜리버리)
//   serviceType: '0',
//   customCostStatus: 1,
//   roundTrip: 'N',
//   payType: 2
// }
const initialState = {
  pageCount: 1, // 페이지 구별 nav 색상 변경
  complate: false,
  orderNo: 0,
  assignType: 0,
  data: {
    requestOrderType: 2,
    callType: 3,
    user: {
      type: 2,
      name: '',
      phoneNo: '',
      branchCode: '',
      checkType: 2,
    },
    refTransNo: '',
    transNo: '',
    productType: 2,
    productServiceType: 1,
    routes: [
      {
        locationName: '',
        phoneNo: '',
        addr: '',
        addrDetail: '',
        lat: '',
        lon: '',
        locationType: '001',
        car: {
            brand: '',
            vehicleModel: '',
            carNo: '',
        },
      },
      {
        locationName: '',
        phoneNo: '',
        addr: '',
        addrDetail: '',
        lat: '',
        lon: '',
        locationType: '009',
        car: {},
      }
    ], //  필요 값: locationName (이름), phoneNo (연락처), addr (출발지주소), addrDetail(주소상세), locationType (001:출발지 , 009:도착지)
    reservationDate: '', // 예약 일자
    assignType: 3, // 배차유형
    assignDetail: '', // 배차유형 상세 (P: 픽업, D: 딜리버리)
    serviceType: '0',
    customCostStatus: 1,
    roundTrip: 'N',
    memo: '',
    remark: '', // 전달사항 (요금 상세내역 입력 {} <- 사용);
    payAmount: 0,
    payType: 2
  }, // 오더 접수시 보낼 데이터
  PDdata: {
    requestOrderType: 2,
    callType: 3,
    user: {
      type: 2,
      name: '',
      phoneNo: '',
      branchCode: '',
      checkType: 2,
    },
    refTransNo: '',
    transNo: '',
    productType: 2,
    productServiceType: 1,
    routes: [
      {
        locationName: '',
        phoneNo: '',
        addr: '',
        addrDetail: '',
        lat: '',
        lon: '',
        locationType: '001',
        car: {
            brand: '',
            vehicleModel: '',
            carNo: '',
        },
      },
      {
        locationName: '',
        phoneNo: '',
        addr: '',
        addrDetail: '',
        lat: '',
        lon: '',
        locationType: '009',
        car: {},
      }
    ], //  필요 값: locationName (이름), phoneNo (연락처), addr (출발지주소), addrDetail(주소상세), locationType (001:출발지 , 009:도착지)
    reservationDate: '', // 예약 일자
    assignType: 3, // 배차유형
    assignDetail: '', // 배차유형 상세 (P: 픽업, D: 딜리버리)
    serviceType: '0',
    customCostStatus: 1,
    roundTrip: 'N',
    memo: '',
    remark: '', // 전달사항 (요금 상세내역 입력 {} <- 사용);
    payAmount: 0,
    payType: 2
  }, // 픽업&딜리버리 데이터
  cardData: { // 카드 데이터 저장
    orderNo: 0,
    cn: '',
    cexm: 0,
    cexy: 0
  },
  PDcardData: {
    orderNo: 0,
    cn: '',
    cexm: 0,
    cexy: 0,
  }
}

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    dataChange: (state, actions) => {
      state.data = actions.payload;
    },
    PDdataChange: (state, actions) => {
      state.data = actions.payload;
      state.PDdata = actions.payload;
    },
    nextPage: (state) => {
      state.pageCount += 1;
    },
    backPage: (state) => {
      if(state.pageCount < 2) {
        state.pageCount = 1
      } else {
        state.pageCount -= 1;
      }
    },
    resetPage: (state) => {
      state.pageCount = 1;
    },
    addressPush: (state, actions) => {
      // state.data.routes = actions.payload
      state.data.routes[0].addr = actions.payload.sendAddr;
      state.data.routes[0].addrDetail = actions.payload.sendAddrDetail;
      state.data.routes[0].lat = actions.payload.sendLat;
      state.data.routes[0].lon = actions.payload.sendLon;

      state.data.routes[1].addr = actions.payload.endAddr;
      state.data.routes[1].addrDetail = actions.payload.endAddrDetail;
      state.data.routes[1].lat = actions.payload.endLat;
      state.data.routes[1].lon = actions.payload.endLon;
    },
    PDaddressPush: (state, actions) => {
      state.PDdata.routes[0].addr = actions.payload.sendAddr;
      state.PDdata.routes[0].addrDetail = actions.payload.sendAddrDetail;
      state.PDdata.routes[0].lat = actions.payload.sendLat;
      state.PDdata.routes[0].lon = actions.payload.sendLon;
      state.PDdata.routes[1].addr = actions.payload.endAddr;
      state.PDdata.routes[1].addrDetail = actions.payload.endAddrDetail;
      state.PDdata.routes[1].lat = actions.payload.endLat;
      state.PDdata.routes[1].lon = actions.payload.endLon;
    },
    nowPage: (state, actions) => {
      let path = actions.payload;
      if(path === '/') {
        state.pageCount = 1
      } else if (path === '/address') {
        state.pageCount = 2
      } else if (path === '/price') {
        state.pageCount = 3
      } else if (path === '/fin') {
        state.pageCount = 4
      }
    },
    driveNowPage: (state, actions) => {
      let num = actions.payload;
      if(num === '01') {
        state.pageCount = 5;
      } else if (num === '02') {
        state.pageCount = 6;
      } else if (num === '03') {
        state.pageCount = 7;
      } else if (num === '04') {
        state.pageCount = 8;
      } else if (num === '99') {
        state.pageCount = 99;
      }
    },
    memoPush: (state, actions) => {
      state.data.memo = actions.payload
    },
    orderFin: (state) => {
      state.complate = true;
    },
    orderNoPush: (state, actions) => {
      state.orderNo = actions.payload;
    },
    orderDate: (state, actions) => {
      state.data.reservationDate = actions.payload;
    },
    PDorderDate: (state, actions) => {
      state.PDdata.reservationDate = actions.payload;
    },
    PDorderAssignType: (state, actions) => {
      state.assignType = actions.payload.pickAndDeli;
      state.data.assignType = actions.payload.pickup;
      state.PDdata.assignType = actions.payload.deli;
    },
    PDreset: (state) => {
      state.assignType = 0;
    },
    cardDataInsert: (state, actions) => {
      console.log(actions)
      state.cardData = actions.payload;
    },
    PDcardDataInsert: (state, actions) => {
      console.log(actions);
      state.PDcardData = actions.payload;
    },
    priceDetailpush: (state, actions) => {
      state.data.remark = actions.payload;
      state.PDdata.remark = actions.payload;
    }
  },
})

export const { PDcardDataInsert ,cardDataInsert, PDreset, PDorderAssignType, PDorderDate, PDaddressPush, PDdataChange, memoPush, orderNoPush, orderFin , nextPage, backPage, dataChange, resetPage, addressPush, nowPage, driveNowPage , orderDate } = counterSlice.actions

export default counterSlice.reducer